module.exports = __webpack_public_path__ + "img/sh002.71e7d645.png";